import { useSelector } from "react-redux";
import { useHomeBannersFetch } from "../../hooks/useHomeBannersFetch";
import { Carousel as SingleCarousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { LOGO } from "../../utils/Constants";

function AdvBanner() {
  const { banners, adBanners } = useSelector((state) => state.banner);

  const handleImageError = (event) => {
    event.target.src = LOGO;
  };

  useHomeBannersFetch();
  return (
    <div className="container container-lg pb-10">
      <div className="row gy-4">
        <div className="col-md-8 gx-2">
          <SingleCarousel showThumbs={false} showStatus={false} autoPlay={true}>
            {banners.map((banner, index) => {
              return (
                <div className="adv-banner" key={index}>
                  <img
                    src={banner.image || LOGO} // Fallback to LOGO if item.image is empty
                    alt={banner.image}
                    onError={handleImageError} // Call handleImageError if image fails to load
                    className="rounded-10"
                  />
                </div>
              );
            })}
          </SingleCarousel>
        </div>
        <div className="col-md-4 gx-2">
          <SingleCarousel showThumbs={false} showStatus={false} autoPlay={true}>
            {adBanners.map((adBanner, index) => {
              return (
                <div className="adv-banner" key={index}>
                  <img
                    src={adBanner.image || LOGO} // Fallback to LOGO if item.image is empty
                    alt={adBanner.image}
                    onError={handleImageError} // Call handleImageError if image fails to load
                    className="rounded-10"
                  />
                </div>
              );
            })}
          </SingleCarousel>
        </div>
      </div>
    </div>
  );
}

export default AdvBanner;
